/**
 * @generated SignedSource<<3a1f802e6e851d2be950d33eb19db0d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationSubject"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rlimit"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "severity"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewed"
},
v11 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  },
  {
    "kind": "Variable",
    "name": "endTs",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "notificationSubject",
    "variableName": "notificationSubject"
  },
  {
    "kind": "Variable",
    "name": "notificationType",
    "variableName": "notificationType"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "rlimit",
    "variableName": "rlimit"
  },
  {
    "kind": "Variable",
    "name": "severity",
    "variableName": "severity"
  },
  {
    "kind": "Variable",
    "name": "startTs",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  },
  {
    "kind": "Variable",
    "name": "viewed",
    "variableName": "viewed"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "NotificationEntriesConnection",
        "kind": "LinkedField",
        "name": "getnotificationentriesforuser",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationsList_al"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "NotificationEntriesConnection",
        "kind": "LinkedField",
        "name": "getnotificationentriesforuser",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationEntry",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationSubject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationBody",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "severity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewed",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d1ecc0aab2cac2bb808541b58e8ff8e",
    "id": null,
    "metadata": {},
    "name": "NotificationsQuery",
    "operationKind": "query",
    "text": "query NotificationsQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $accountId: UUID\n  $userId: UUID\n  $severity: String\n  $notificationType: String\n  $notificationSubject: String\n  $viewed: Int\n  $rlimit: Int\n  $first: Int\n  $offset: Int\n) {\n  getnotificationentriesforuser(startTs: $startDate, endTs: $endDate, accountId: $accountId, userId: $userId, severity: $severity, notificationType: $notificationType, notificationSubject: $notificationSubject, viewed: $viewed, rlimit: $rlimit, first: $first, offset: $offset) {\n    totalCount\n    ...NotificationsList_al\n  }\n}\n\nfragment NotificationsList_al on NotificationEntriesConnection {\n  nodes {\n    notificationId\n    accountId\n    userId\n    notificationType\n    notificationSubject\n    notificationBody\n    notificationTime\n    severity\n    notificationUserId\n    viewed\n  }\n}\n"
  }
};
})();

node.hash = "fad2ec85fa5f4c0a60216bba3695c18f";

module.exports = node;
